// react core
import { useContext, useRef } from "react";

// material design
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// entzy resources
import configEntzy from "components/config/ConfigEntzy";
import GooglePlace from "components/utils/google/GooglePlace";

// entzy context and services
import { EventContext } from "components/event/EventContext";

function ActionLocationsRunner(props) {
  const eventContext = useContext(EventContext);
  const roomContainerRef = useRef();

  const handleRunnerActionCallback = async (data) => {
    const eventLocations = data;
    if (eventContext.state.event.manager) {
      const response = await eventContext.prepareUpdatePlaces({
        key: "Locations",
        value: eventLocations,
        category: "runner",
      });
      if (response.alert) {
        return {
          alert: true,
          message: response.message,
        };
      } else {
        eventContext.updatePlaces(response);
        props.handleCloseAction();
        return { alert: false };
      }
    } else {
      return {
        alert: true,
        message: "Event runner permissions required for this update",
      };
    }
  };

  return (
    <Box
      ref={roomContainerRef}
      className="box-default"
      sx={{
        px: configEntzy.APP_SPACING_MD,
      }}
    >
      <Box className="box-default">
        <Typography variant="h6" color="primary">
          Launch Location
        </Typography>
        <Typography variant="subtitle1" color="white">
          <em>Set the launch place and any other sites</em>
        </Typography>
      </Box>
      <Box className="box-default" sx={{ mt: configEntzy.APP_SPACING_MD2X }}>
        <GooglePlace
          user={props.user}
          manager={eventContext.state.event.manager}
          locations={eventContext.state.places.data.combined}
          country={eventContext.state.event.data.Country}
          toggleConnect={eventContext.toggleConnect}
          editView={true}
          callback={handleRunnerActionCallback}
          roomContainerRef={roomContainerRef}
          runnerAction={true}
          riderAction={false}
        />
      </Box>
    </Box>
  );
}

export default ActionLocationsRunner;
